
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/telus",
      function () {
        return require("private-next-pages/telus/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/telus"])
      });
    }
  